import { useState } from 'react';
import Button from 'src/components/buttons/button';
import config from 'config/config';
import Icon from 'src/components/icon';

const PROGRAM_URL = `${config.cdn.navigator}lower-your-cholesterol/`;

const getMenu = () => (
  <section className="navigator__contents">
    <div className="navigator__contents-header">Contents</div>
    <ul className="navigator__contents__list">
      <li>
        <div className="navigator__contents__number">1.</div>
        <div className="navigator__contents__content-text">
          <a href="#1">How physical activity lowers cholesterol</a>
        </div>
      </li>
      <li>
        <div className="navigator__contents__number">2.</div>
        <div className="navigator__contents__content-text">
          <a href="#2">How to start moving more</a>
        </div>
      </li>
      <li>
        <div className="navigator__contents__number">3.</div>
        <div className="navigator__contents__content-text">
          <a href="#3">How walking changes lives</a>
        </div>
      </li>
    </ul>
  </section>
);

const getPage = () => (
  <div className="navigator">
    <section className="navigator__content">
      <h1 className="navigator__title">{'Week 7: Start moving more'}</h1>
      <p>
        Being regularly active has been proven to lower your risk of heart and circulatory diseases over time. In
        particular, it helps lower cholesterol levels. This week we’ll share tips on how much to move and how to build
        it into your life in a way that’s achievable and enjoyable.
      </p>
      <div className="visible-xs">{getMenu()}</div>

      <h2>How physical activity lowers cholesterol</h2>
      <p>
        We all know that physical activity is good for us, but it’s especially important if you have high cholesterol.
        Research shows that being regularly active can help lower cholesterol and reduce your risk of heart and
        circulatory diseases.
      </p>
      <p>Physical activity helps increase your ‘good’ (HDL) cholesterol and lower your ‘bad’ (non-HDL) cholesterol.</p>
      <div className="navigator__video-container">
        <iframe
          allow="autoplay; encrypted-media; fullscreen"
          src="https://www.youtube.com/embed/wWGulLAa0O0"
        />
      </div>

      <h2>How to start moving more</h2>
      <p>
        Look for things you can do that make you breathe harder, feel warmer and your heart beat faster. You don’t have
        to be flat out - you should still be able to hold a conversation.
      </p>
      <p>
        <strong>Aim to be active for about half an hour a day, 5 days a week at least.</strong>
      </p>
      <p>
        You’d be surprised how many activities count as part of your 30 minutes a day. Walking, swimming, gardening and
        climbing the stairs are all heart-healthy activities.
      </p>
      <p>
        Click on the image below for tips on getting more active in your everyday life.
      </p>
      <a href="https://images.hu-production.be/programs/lower-your-cholesterol/W07B02.jpg" rel="noreferrer" target="_blank">
        <img alt="Active vs sedentary life" className="navigator__image-full" src={`${PROGRAM_URL}W07B02.jpg`} />
      </a>
      <a
        href="https://www.bhf.org.uk/heart-health/preventing-heart-disease/staying-active/getting-active"
        rel="noreferrer"
        target="_blank"
      >
        <Button
          icon="open-right"
          iconLeftAligned={false}
          text="How to be more active"
        />
      </a>

      <h2>How walking changes lives</h2>
      <p>
        This group of friends set up their own walking group to protect their health, explore their city and be there
        for each other. See how they did it and get inspired.
      </p>
      <div className="navigator__video-container">
        <iframe
          allow="autoplay; encrypted-media; fullscreen"
          src="https://www.youtube.com/embed/7TiagQ_jyb4"
        />
      </div>

      <img alt="Content provided by BHF" className="navigator__image-full navigator__banner-footer" src={`${PROGRAM_URL}bhf-content.jpg`} />
    </section>
  </div>
);

function Footer() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;
  return (
    <div className="navigator__footer">
      <img alt="HealthUnlocked British Heart Foundation community screenshot" className="navigator__footer__image" src={`${PROGRAM_URL}cta-community.png`} />
      <div className="navigator__footer__inner">
        <div className="navigator__footer__title">Join the conversation on HealthUnlocked</div>
        <div className="navigator__footer__description">
          To get the most out of your heart health journey, you’ll need support. Our online community on
          HealthUnlocked brings patients, their loved-ones and healthcare experts all together online to share advice
          and encouragement.{' '}
          <a
            className="navigator__footer__link"
            href="https://healthunlocked.com/bhf"
            rel="noreferrer"
            target="_blank"
          >
            Join the conversation {'>'}
          </a>
        </div>
        <div className="navigator__footer__close" onClick={() => setVisible(false)}>
          <Icon icon="cross" />
        </div>
      </div>
    </div>
  );
}

const obj = {
  getPage,
  getMenu,
  Footer,
  getSeoTitle: 'Lower your cholesterol | HealthUnlocked',
};

export default obj;
